import type { FreeSlot } from '@hedepy/common/schemas/modules/schedule/freeSlot'
import { useMemo } from 'react'
import useSWR from 'swr'

import { useApis } from '../contexts/api-context'

const fetchFunction = async (api: any, therapistId: number, dateTo: number, serviceId: number): Promise<FreeSlot[]> => {
  const res = await api.getFreeSlots(therapistId, dateTo, serviceId)
  return res.data
}

export interface UseFreeSlots {
  therapistId: number
  dateTo: number
  serviceId: number
}

const useFreeSlots = ({ therapistId, dateTo, serviceId }: UseFreeSlots) => {
  const { api } = useApis()

  const { data, isLoading, mutate } = useSWR(['useFreeSlots', therapistId, dateTo, serviceId], () =>
    fetchFunction(api, therapistId, dateTo, serviceId),
  )

  const slots = useMemo(() => {
    // Filter out slots older than 31 days, since the backend sometimes returns
    // them and they can not be relied upon
    const dateFrom = dateTo - 31 * 24 * 60 * 60 // dateTo - 31 days

    return data?.filter((slot) => new Date(slot.startDate).getTime() * 0.001 > dateFrom)
  }, [data, dateTo])

  return { slots, isLoading, refetchSlots: mutate }
}

export default useFreeSlots
